import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageSquare, Mail, Clock, FileText } from 'lucide-react';
import MainLayout from '../../components/layout/MainLayout';
import AutomationTabBar from '../../components/automation/AutomationTabBar';
import GroqApiKeySetup from '../../components/automation/GroqApiKeySetup';
import GroqKeyRequired from '../../components/automation/GroqKeyRequired';
import api from '../../utils/api';

const AutomationHub = () => {
  const [activeTab, setActiveTab] = useState('web');
  const [keyIsSet, setKeyIsSet] = useState(true);
  const navigate = useNavigate();

  const handleScrollToSetup = () => {
    document.getElementById('api-key-setup')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <MainLayout>
      <div style={{ padding: '24px' }}>
        <h1 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '24px' }}>Automation</h1>
        
        {!keyIsSet && (
          <GroqKeyRequired onSetupClick={handleScrollToSetup} />
        )}

        <AutomationTabBar activeTab={activeTab} setActiveTab={setActiveTab} />
        
        <div style={{ marginTop: '24px' }}>
          
          {activeTab === 'api' && (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px' }}>
              <div 
                onClick={() => navigate('/automation/whatsapp-api/bulk')}
                style={{ background: 'white', padding: '24px', borderRadius: '12px', border: '1px solid var(--color-border-primary)', cursor: 'pointer', transition: 'box-shadow 0.2s' }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
                  <div style={{ background: '#dcfce7', padding: '12px', borderRadius: '12px' }}>
                    <MessageSquare size={24} color="#16a34a" />
                  </div>
                  <h2 style={{ fontSize: '20px', fontWeight: 'bold' }}>WhatsApp API Bulk</h2>
                </div>
                <p style={{ color: 'var(--color-text-secondary)', lineHeight: '1.5' }}>Send official Meta-approved template messages to large lists. Best for verified businesses.</p>
              </div>

              <div 
                onClick={() => navigate('/automation/whatsapp-api/ai-reply')}
                style={{ background: 'white', padding: '24px', borderRadius: '12px', border: '1px solid var(--color-border-primary)', cursor: 'pointer', transition: 'box-shadow 0.2s' }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
                  <div style={{ background: '#f3e8ff', padding: '12px', borderRadius: '12px' }}>
                    <span style={{ fontSize: '24px' }}>🤖</span>
                  </div>
                  <h2 style={{ fontSize: '20px', fontWeight: 'bold' }}>AI Auto-Reply (Groq)</h2>
                </div>
                <p style={{ color: 'var(--color-text-secondary)', lineHeight: '1.5' }}>Configure smart auto-reply for incoming WhatsApp messages.</p>
              </div>
            </div>
          )}

          {activeTab === 'web' && (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px' }}>
              <div 
                onClick={() => navigate('/automation/whatsapp-web/bulk')}
                style={{ background: 'white', padding: '24px', borderRadius: '12px', border: '1px solid var(--color-border-primary)', cursor: 'pointer', transition: 'box-shadow 0.2s' }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
                  <div style={{ background: '#e0e7ff', padding: '12px', borderRadius: '12px' }}>
                    <MessageSquare size={24} color="#4f46e5" />
                  </div>
                  <h2 style={{ fontSize: '20px', fontWeight: 'bold' }}>WhatsApp Web Bulk</h2>
                </div>
                <p style={{ color: 'var(--color-text-secondary)', lineHeight: '1.5' }}>Send automated bulk messages through your connected phone with smart anti-ban protection.</p>
              </div>
            </div>
          )}

          {activeTab === 'email' && (
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '24px' }}>
              <div 
                onClick={() => navigate('/automation/email/send')}
                style={{ background: 'white', padding: '24px', borderRadius: '12px', border: '1px solid var(--color-border-primary)', cursor: 'pointer', transition: 'box-shadow 0.2s' }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
                  <div style={{ background: '#fef3c7', padding: '12px', borderRadius: '12px' }}>
                    <Mail size={24} color="#d97706" />
                  </div>
                  <h2 style={{ fontSize: '20px', fontWeight: 'bold' }}>Send Cold Emails</h2>
                </div>
                <p style={{ color: 'var(--color-text-secondary)', lineHeight: '1.5' }}>Select leads and send personalized cold email campaigns.</p>
              </div>

              <div 
                onClick={() => navigate('/automation/email/history')}
                style={{ background: 'white', padding: '24px', borderRadius: '12px', border: '1px solid var(--color-border-primary)', cursor: 'pointer', transition: 'box-shadow 0.2s' }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
                  <div style={{ background: '#f1f5f9', padding: '12px', borderRadius: '12px' }}>
                    <Clock size={24} color="#475569" />
                  </div>
                  <h2 style={{ fontSize: '20px', fontWeight: 'bold' }}>Campaign History</h2>
                </div>
                <p style={{ color: 'var(--color-text-secondary)', lineHeight: '1.5' }}>View all past email campaigns and their delivery results.</p>
              </div>

              <div 
                onClick={() => navigate('/automation/email/templates')}
                style={{ background: 'white', padding: '24px', borderRadius: '12px', border: '1px solid var(--color-border-primary)', cursor: 'pointer', transition: 'box-shadow 0.2s' }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
                  <div style={{ background: '#ecfdf5', padding: '12px', borderRadius: '12px' }}>
                    <FileText size={24} color="#059669" />
                  </div>
                  <h2 style={{ fontSize: '20px', fontWeight: 'bold' }}>Manage Templates</h2>
                </div>
                <p style={{ color: 'var(--color-text-secondary)', lineHeight: '1.5' }}>Create and manage reusable email templates with dynamic variables.</p>
              </div>
            </div>
          )}

        </div>

        <div id="api-key-setup" style={{ marginTop: '48px', paddingTop: '24px', borderTop: '1px solid var(--color-border-tertiary)' }}>
          <h2 style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '16px' }}>AI Integrations</h2>
          <GroqApiKeySetup onKeyUpdate={setKeyIsSet} />
        </div>
      </div>
    </MainLayout>
  );
};

export default AutomationHub;
